// 正则
export const Exp = {
    //工信部发文2017年第10批
    mobile: /^134[0-8]\d{7}$|^13[^4]\d{8}$|^14[5-9]\d{8}$|^15[^4]\d{8}$|^16[6]\d{8}$|^17[0-8]\d{8}$|^18[\d]{9}$|^19[8,9]\d{8}$/,

    //身份证
    // idCard: /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|[xX])$/,
    idCard: /^[1-9]{1}[0-9]{14}$|^[1-9]{1}[0-9]{16}([0-9]|[xX])$/,

    //密码 支持 ~!@#$%^&*()-_+={}[]<>,.?/:;'|\ 特殊字符
    password: /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[~_\-#@&?*^=!.$%&])[\da-zA-Z~_\-#@&?*^=!.$%&]{12,20}$/,
    regEn: /[`~()+<>:"{}|,\/;'\\[\]·~！￥……（）——+{}|《》？：“”【】、；‘'，。、]/,
};

export const ACCEPT_CONFIG = {
    image: ['.png', '.jpg', '.jpeg', '.gif', '.bmp'],
    video: ['.mp4', '.rmvb', '.mkv', '.wmv', '.flv', '.avi'],
    document: ['.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx', '.pdf', '.txt', '.tif', '.tiff'],
    audio: [".aiff", ".aif", ".wav", ".mp3", ".wma", ".flac", ".ogg", ".aac", ".amr", ".m4a"],
    zip: ['.zip'],
    getAll(){
        return [...this.image, ...this.video, ...this.document, ...this.audio, ...this.zip]
    },
    getSome(){
        return [...this.image, ...this.video, ...this.document, ...this.audio]
    }
};

// md5 密钥
export const SECRET_KEY_MD5 = 'amFtZXNuaXViaQ=='

// 默认密码
export const DEFAULT_PWD = 'apy1234!'

// 职鉴图像操作
export const FISCAN_OPERATE = [
    {
        name: '默认',
        type: 0,
        className: 'default',
        keyboard: '',
    },
    {
        name: '加亮',
        type: 1,
        className: 'jialiang',
        keyboard: 'T',
    },
    {
        name: '加暗',
        type: 2,
        className: 'jiaan',
        keyboard: 'R',
    },
    {
        name: '反转',
        type: 3,
        className: 'fanzhuan',
        keyboard: 'E',
    },
    {
        name: '黑白',
        type: 4,
        className: 'heibai',
        keyboard: 'A',
    },
    {
        name: '有机物剔除',
        type: 9,
        className: 'youjiwutichu',
        keyboard: 'W',
    },
    {
        name: '超级加亮',
        type: 6,
        className: 'chaojijialiang',
        keyboard: 'F1',
    },
    {
        name: '超级加暗',
        type: 7,
        className: 'chaojijiaan',
        keyboard: 'F2',
    },
    {
        name: '无机物剔除',
        type: 8,
        className: 'wujiwutichu',
        keyboard: 'F3',
    },
]
